import { grey700, purple100 } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  .cardIcon-background {
    background-color: ${purple100};
    border-radius: 12px;
    padding: ${spacing(4)} ${spacing(8)};
  }

  .add-color {
    text-align: center;
    color: ${grey700};
  }

  .AlertPanel.default {
    color: initial;
  }

  .alert-text {
    color: ${grey700};
  }
`
